module.exports = __webpack_public_path__ + "static/hero-top-1-7498f38dc20bcd06fcfd8b4a9b67f382.png";